import React from "react";
import { FiPlus, FiTrendingUp } from "react-icons/fi";
import "./PromotionPageHeader.css";

const PromotionPageHeader = ({
  title = "Promotions",
  description = "Discover exclusive partner promotions, featured properties, and special project campaigns.",
  onOpenCreate,
  canCreate = true,
  totalCount,
}) => {
  return (
    <div className="promo-page-header">
      <div className="promo-page-header__content">
        <div className="promo-page-header__badge">
          <FiTrendingUp className="promo-page-header__badge-icon" />
          <span>Promotion Hub</span>
          {typeof totalCount === "number" && (
            <span className="promo-page-header__count-tag">{totalCount} Listed</span>
          )}
        </div>
        <h1 className="promo-page-header__title">{title}</h1>
        <p className="promo-page-header__description">{description}</p>
      </div>

      {canCreate && (
        <div className="promo-page-header__actions">
          <button
            type="button"
            className="promo-page-header__create-btn"
            onClick={onOpenCreate}
          >
            <FiPlus size={18} />
            <span>Create Promotion</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default PromotionPageHeader;
